import React from 'react';
import { BasicRequestParser } from '../constants';
import { DataOptions } from 'cb-utils/console-entity-models';
import { TriggerSourceDefinition } from '../types';
import { CollectionConditionOptions } from './utils';

const CollectionUpdated: TriggerSourceDefinition = {
  name: DataOptions.CollectionUpdated,
  getSummary: (defKeyObject) => (
    <div>
      <em>
        {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore */}
        {defKeyObject.collectionName ? `Collection ${defKeyObject.collectionName} updated` : 'Collection Updated'}
      </em>
    </div>
  ),
  requestParser: BasicRequestParser,
  conditionOptions: CollectionConditionOptions,
};

export default CollectionUpdated;
